import { PathSegment } from './path-segment.js';

export function getPathSegment(path: string) {
  const paths: PathSegment[] = path
    .split('/')
    .filter((s) => !!s)
    .map((s) => ({ path: s, type: 'path' }));
  return paths;
}
